import { cx } from '@linaria/core';

import { SubHeadline } from '~components/Typography';
import QuestionMarkIcon from '~public/assets/icons/question-mark-2.svg';
import CheckIcon from '~public/img/bot-wizard/check.svg';
import { NeuronImage } from '~shared/ui/atoms';

import { ImageRenderer } from '../ImageRenderer';
import {
	Badge,
	ComingSoon,
	Content,
	imageStyle,
	Neurons,
	StyledCardButton,
	Text,
} from './styles';
import type { CardButtonProps } from './types';

export const CardButton = ({
	children,
	text,
	image,
	selected,
	width,
	height,
	aspectRatio = 'square',
	desktopAspectRatio,
	multiline,
	className,
	neurons,
	quality,
	priority,
	badge,
	isComingSoon = false,
	clickable = true,
	...rest
}: CardButtonProps) => {
	return (
		<StyledCardButton
			className={cx(
				className,
				aspectRatio,
				desktopAspectRatio && `desktop-${desktopAspectRatio}`,
				selected && 'selected',
				clickable && 'clickable'
			)}
			{...rest}
		>
			{!!neurons && (
				<Neurons>
					<SubHeadline size="XS">{neurons}</SubHeadline>
					<NeuronImage />
				</Neurons>
			)}

			{badge && !selected && <Badge size="Badge">{badge}</Badge>}

			{clickable && !isComingSoon && <CheckIcon />}

			{isComingSoon && (
				<ComingSoon>
					<QuestionMarkIcon />
				</ComingSoon>
			)}

			{!isComingSoon && (
				<ImageRenderer
					alt={text || '_'}
					className={cx(imageStyle)}
					width={width}
					quality={quality}
					priority={priority}
					height={height}
					fallback={image}
				/>
			)}

			<Content>
				<Text multiline={multiline} size="M">
					{text}
				</Text>
			</Content>

			{children}
		</StyledCardButton>
	);
};
